<template>
  <router-view />
</template>

<script>
import store, { name } from '@/modules/certificationLoad/store';

export default {
  name: 'CertificationLoadWrapper',
  mixins: [],
  created() {
    if (this.$store.state[name] == undefined) {
      this.$store.registerModule(name, store);
    }
  },
  destroyed() {
    //Reset State Method
    this.$store.dispatch(`${name}/reset`); //Reset state
  },
};
</script>
